//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import checker from "@/components/Checker";
import CustomChecker from "@/components/CustomChecker";

export default {
    components: { checker, CustomChecker },
    props: {
        bankInfo: {
            required: true,
        },
        accountId: {},
        showIcon: {
            default: true,
        },
        showCustomIcon: {
            type: Boolean,
            default: false,
        },
    },
};
